module.exports = __webpack_public_path__ + "static/media/webinars-banner.3d21ddb1.jpg";